<template>
  <div>
    <Modal @closeModal="$emit('closeTriggered')">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="modal-title font-weight-bold text-capitalize text-center"
          >SET UP YOUR CLASSESS</span
        >
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body">
        <!-- ERROR ALERT -->
        <div style="position: relative; top: -30px; margin-bottom: -8px">
          <AuthAlertCard
            v-if="show_alert"
            :alert_type="alert_type"
            :alert_msg="alert_msg"
          ></AuthAlertCard>
        </div>

        <form action @submit.prevent="updateSchoolType">
          <div class="container px-1">
            <div
              class="meta-title color_grey_dark font-14 font-weight-bold text-uppercase mb-3"
            >
              SCHOOL TYPE
            </div>

            <div class="form_group school_type">
              <div class="item">
                <label for="primary" class="radio pointer">
                  <input
                    type="radio"
                    id="primary"
                    value="primary"
                    v-model="form.school_type"
                  />
                  <span class="label_title">Primary school only</span>
                </label>
              </div>

              <div class="item">
                <label for="secondary" class="radio pointer">
                  <input
                    type="radio"
                    id="secondary"
                    value="secondary"
                    v-model="form.school_type"
                  />
                  <span class="label_title">Secondary school only</span>
                </label>
              </div>

              <div class="item">
                <label for="primSec" class="radio pointer">
                  <input
                    type="radio"
                    id="primSec"
                    value="all"
                    v-model="form.school_type"
                  />
                  <span class="label_title">Primary and Secondary school</span>
                </label>
              </div>
            </div>

            <div
              class="meta-title color_grey_dark font-14 font-weight-bold text-uppercase mb-3 mt-3"
            >
              NAMING STYLE
            </div>

            <label for="year" class="style-label">
              <input
                type="radio"
                name="style"
                id="year"
                v-model="form.school_format"
                value="year"
              />
              <div>
                <div class="font-14 font-weight-600 mb-2">Year 1-12</div>
                <div class="border-grey font-12">
                  Use the K-12 naming style of Year 1 - Year 12
                </div>
              </div>
            </label>

            <label for="ss" class="style-label mb-4">
              <input
                type="radio"
                name="style"
                id="ss"
                v-model="form.school_format"
                value="ss"
              />
              <div>
                <div class="font-14 font-weight-600 mb-2">
                  Primary 1-6/ JSS 1-SS 3
                </div>
                <div class="border-grey font-12">
                  Use the defualt Nigerian class naming style of Nursery,
                  Primary, Junior and Senior secondary class
                </div>
              </div>
            </label>
          </div>

          <!-- CANCEL OR SUBMIT FORM -->
          <div
            class="row d-flex justify-content-center align-items-center nowrap"
          >
            <button
              @click="$emit('closeTriggered')"
              class="btn btn-md black-ic z-depth-0 mr-3"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-md btn-accent ml-3"
              ref="saveBtn"
            >
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Modal from "@/components/globalComps/Modal";
import { setTimeout } from "timers";

export default {
  name: "SchoolTypeModal",

  components: {
    Modal,
    AuthAlertCard: () =>
      import(
        /* webpackChunkName: "AuthAlertCard" */ "@/components/globalComps/AuthComps/AuthAlertCard.vue"
      ),
  },

  props: {
    school_type_data: String,
    naming_format_data: String,
  },

  data() {
    return {
      form: {
        school_type: this.school_type_data,
        school_format: "ss",
      },
      show_alert: false,
      alert_type: null, //SET TO EITHER SUCCESS OR ERROR
      alert_msg: null,
    };
  },

  methods: {
    ...mapActions(["generateClasses"]),

    updateSchoolType() {
      this.$refs.saveBtn.disabled = true;
      this.$refs.saveBtn.innerHTML =
        '<div class="icon-dotted-roller font-17 mr-2 animate"></div>Please wait...';

      this.generateClasses(this.form)
        .then((response) => {
          // console.log(response);

          if (response.code === 200) {
            setTimeout(() => {
              this.show_alert = false;

              this.$refs.saveBtn.disabled = true;
              this.$refs.saveBtn.innerHTML =
                '<div class="icon-accept font-18 mr-2"></div>Successful';
            }, 1000);

            setTimeout(() => {
              let dialog_data = {
                msg: "School type updated successfully...",
                type: "success",
              };
              this.$emit("showAlertCard", dialog_data);
              this.$emit("closeTriggered");
            }, 3000);
          }
          // HANDLE A NON 200 RESPONSE
          else {
            setTimeout(() => {
              this.show_alert = true;
              this.alert_type = "error";
              this.alert_msg =
                "Request cannot be made. Contact Gradely support for assistant";

              this.$refs.saveBtn.disabled = false;
              this.$refs.saveBtn.innerHTML = "Save Changes";
            }, 1000);

            setTimeout(() => (this.show_alert = false), 5000);
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-title {
  @include breakpoint_max(sm) {
    font-size: 13px !important;
  }
}

.type-text {
  @include breakpoint_max(sm) {
    font-size: 12px !important;
  }
}

.meta-title {
  @include breakpoint_max(sm) {
    font-size: 12.5px !important;
  }
}

.school_type {
  .item {
    margin-bottom: 7px;
    .label_title {
      font-size: 13px;
      margin-left: 6px;

      @include breakpoint_max(sm) {
        position: relative;
        top: -3px;
        font-size: 12px !important;
      }
    }
  }
}

.style-label {
  border: 1.2px solid $border_grey;
  border-radius: 6px;
  padding: 12px 15px;
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 0 10px;
}
</style>
